<template>
  <settings-modal
    class="t-currency-rate-edit-modal"
  >
    <span
      slot="heading"
      class="font-weight-bold"
    >Edit {{ rate.currency }} rate</span>
    <v-layout row>
      <v-flex xs4>
        <v-text-field
          v-model="form.rate"
          type="number"
          label="Rate"
          class="t-rate-input"
          :error-messages="getValidationErrorMessage('rate')"
        />
      </v-flex>
    </v-layout>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-save-button"
        color="primary"
        medium
        flat
        @click="onSaveButtonClick"
      >Save</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapActions } from 'vuex'

  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import CurrencyRatesApi from '@/services/Api/CurrencyRatesApi'

  import SettingsModal from '@/components/modals/SettingsModal.vue'
  import ErrorAlert from '@/components/ui/ErrorAlert.vue'

  import form from '@/mixins/form'
  import modal from '@/mixins/modal'
  import flashMessages from '@/mixins/flashMessages'

  import { EVENT_CURRENCY_RATES_CHANGE } from '@/events/currencyRates'

  export default {
    name: 'CurrencyRatesEditModal',
    components: {
      ErrorAlert,
      SettingsModal
    },
    mixins: [flashMessages, form, modal],
    data () {
      return {
        error: null,
        requiredFields: ['date', 'currency', 'rate'],
        form: {
          date: null,
          currency: null,
          rate: null
        },
        updateCurrencyRateApiRequest: new ApiRequest(CurrencyRatesApi.updateRate)
      }
    },
    computed: {
      rate () {
        return this.modal.data.formData
      }
    },
    created () {
      this.setFormData(this.rate)
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onSaveButtonClick () {
        this.updateCurrencyRateApiRequest
          .execute(this.form)
          .then(() => {
            this.$eventHub.$emit(EVENT_CURRENCY_RATES_CHANGE)

            this.showSuccessFlashMessage('Rate have been successfully edited.')
          })
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      }
    }
  }
</script>
